import { render, staticRenderFns } from "./Resizer.vue?vue&type=template&id=24fc61e6&"
import script from "./Resizer.vue?vue&type=script&lang=js&"
export * from "./Resizer.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./Resizer.vue?vue&type=style&index=0&id=24fc61e6&prod&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "a8556b6a"
  
)

export default component.exports